export enum TipoDependenteEnum {
  Conjuge = 1,
  Companheiro = 2, 
  FilhoOuEnteado = 3, 
  FilhoUniversitarioOuTecnico = 4, 
  IrmaoNetoBisneto = 6, 
  IrmaoUniversitarioOuTecnico = 7, 
  PaisAvosBisavos = 9, 
  MenorPobre = 10, 
  IncapazTutorCurador = 11, 
  ExConjuge = 12, 
  Outros = 99 
}
